const en = {
  complete: 'Complete',
  sign_and_complete: 'Sign and Complete',
  text: 'Text',
  by_clicking_you_agree_to_the: 'By clicking "{button}", you agree to the',
  electronic_signature_disclosure: 'Electronic Signature Disclosure',
  esignature_disclosure: 'eSignature Disclosure',
  signature: 'Signature',
  initials: 'Initials',
  drawn_signature_on_a_touchscreen_device: 'Drawn signature on a touchscreen device',
  approved: 'Approved',
  reviewed: 'Reviewed',
  other: 'Other',
  authored_by_me: 'Authored by me',
  invite: 'Invite',
  email: 'Email',
  approved_by: 'Approved by',
  reviewed_by: 'Reviewed by',
  authored_by: 'Authored by',
  select_a_reason: 'Select a reason',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Scan the QR code with the camera app to open the form on mobile and draw your signature',
  date: 'Date',
  number: 'Number',
  value_is_invalid: 'Value is invalid',
  verification_code_is_invalid: 'Verification code is invalid',
  already_paid: 'Already paid',
  image: 'Image',
  pay: 'Pay',
  take_photo: 'Take photo',
  number_phone_is_invalid: '{number} phone is invalid',
  file: 'File',
  digitally_signed_by: 'Digitally signed by',
  reason: 'Reason',
  select: 'Select',
  checkbox: 'Checkbox',
  multiple: 'Multiple',
  radio: 'Radio',
  cells: 'Cells',
  stamp: 'Stamp',
  minimize: 'Minimize',
  payment: 'Payment',
  phone: 'Phone',
  start_now: 'Start Now',
  continue: 'Continue',
  sign_now: 'Sign Now',
  type_here_: 'Type here...',
  optional: 'optional',
  option: 'Option',
  appears_on: 'Appears on',
  page: 'Page',
  select_your_option: 'Select your option',
  complete_hightlighted_checkboxes_and_click: 'Complete highlighted checkboxes and click',
  submit: 'submit',
  next: 'next',
  click_to_upload: 'Click to upload',
  or_drag_and_drop_files: 'or drag and drop files',
  send_copy_via_email: 'Send copy via email',
  download: 'Download',
  clear: 'Clear',
  redraw: 'Redraw',
  draw_initials: 'Draw initials',
  type_signature_here: 'Type signature here',
  type_initial_here: 'Type initials here',
  form_has_been_completed: 'Form has been completed!',
  document_has_been_signed: 'Document has been signed!',
  documents_have_been_signed: 'Documents have been signed!',
  create_a_free_account: 'Create a Free Account',
  powered_by: 'Powered by',
  please_check_the_box_to_continue: 'Please check the box to continue',
  open_source_documents_software: 'Paperless. Powerful. Professional.',
  verified_phone_number: 'Verify Phone Number',
  use_international_format: 'Use international format: +1xxx',
  six_digits_code: '6-digit code',
  change_phone_number: 'Change phone number',
  sending: 'Sending...',
  resend_code: 'Re-send code',
  verification_code_has_been_resent: 'Verification code has been re-sent via SMS',
  please_fill_all_required_fields: 'Please fill all required fields',
  set_today: 'Set Today',
  toggle_multiline_text: 'Toggle Multiline Text',
  draw_signature: 'Draw signature',
  type_initial: 'Type initials',
  draw: 'Draw',
  type: 'Type',
  type_text: 'Type text',
  email_has_been_sent: 'Email has been sent',
  processing: 'Processing',
  pay_with_strip: 'Pay with Stripe',
  reupload: 'Reupload',
  upload: 'Upload',
  files: 'Files'
}

const es = {
  complete: 'Completar',
  sign_and_complete: 'Firmar y Completar',
  invite: 'Invitar',
  email: 'Correo electrónico',
  approved: 'Aprobado',
  reviewed: 'Revisado',
  other: 'Otro',
  authored_by_me: 'Escrito por mí',
  approved_by: 'Aprobado por',
  reviewed_by: 'Revisado por',
  authored_by: 'Escrito por',
  select_a_reason: 'Selecciona una razón',
  value_is_invalid: 'El valor no es válido',
  verification_code_is_invalid: 'El código de verificación no es válido',
  drawn_signature_on_a_touchscreen_device: 'Firma dibujada en un dispositivo con pantalla táctil',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Escanea el código QR con la aplicación de la cámara para abrir el formulario en el móvil y dibujar tu firma',
  by_clicking_you_agree_to_the: 'Al hacer clic en "{button}", usted acepta el',
  electronic_signature_disclosure: 'Divulgación de Firma Electrónica',
  esignature_disclosure: 'Divulgación de eFirma',
  already_paid: 'Ya pagado',
  minimize: 'Minimizar',
  text: 'Texto',
  signature: 'Firma',
  pay: 'Pagar',
  digitally_signed_by: 'Firmado digitalmente por',
  reason: 'Razón',
  initials: 'Iniciales',
  date: 'Fecha',
  number: 'Número',
  image: 'Imagen',
  file: 'Archivo',
  select: 'Seleccionar',
  checkbox: 'Casilla',
  number_phone_is_invalid: '{number} teléfono es inválido',
  multiple: 'Múltiple',
  radio: 'Radio',
  cells: 'Celdas',
  stamp: 'Sello',
  payment: 'Pago',
  phone: 'Teléfono',
  take_photo: 'Tomar foto',
  start_now: 'Comenzar ahora',
  continue: 'Continuar',
  sign_now: 'Firmar ahora',
  type_here_: 'Escribe aquí...',
  optional: 'opcional',
  appears_on: 'Aparece en',
  page: 'Página',
  select_your_option: 'Selecciona tu opción',
  complete_hightlighted_checkboxes_and_click: 'Completa las casillas resaltadas y haz clic',
  submit: 'enviar',
  next: 'siguiente',
  click_to_upload: 'Haz clic para cargar',
  or_drag_and_drop_files: 'o arrastra y suelta archivos',
  send_copy_via_email: 'Enviar copia por correo electrónico',
  download: 'Descargar',
  clear: 'Borrar',
  redraw: 'Redibujar',
  draw_initials: 'Dibujar iniciales',
  type_signature_here: 'Escribe la firma aquí',
  type_initial_here: 'Escribe las iniciales aquí',
  form_has_been_completed: '¡El formulario ha sido completado!',
  document_has_been_signed: '¡El documento ha sido firmado!',
  documents_have_been_signed: '¡Los documentos han sido firmados!',
  create_a_free_account: 'Crear una Cuenta Gratuita',
  powered_by: 'Desarrollado por',
  please_check_the_box_to_continue: 'Por favor marque la casilla para continuar',
  open_source_documents_software: 'software de documentos de código abierto',
  verified_phone_number: 'Verificar número de teléfono',
  use_international_format: 'Usar formato internacional: +1xxx',
  six_digits_code: 'Código de 6 dígitos',
  change_phone_number: 'Cambiar número de teléfono',
  sending: 'Enviando...',
  resend_code: 'Reenviar código',
  verification_code_has_been_resent: 'El código de verificación ha sido reenviado por SMS',
  please_fill_all_required_fields: 'Por favor, complete todos los campos obligatorios',
  set_today: 'Establecer Hoy',
  toggle_multiline_text: 'Alternar Texto Multilínea',
  draw_signature: 'Dibujar firma',
  type_initial: 'Escribir iniciales',
  draw: 'Dibujar',
  type: 'Escribir',
  type_text: 'Escribir texto',
  email_has_been_sent: 'El correo electrónico ha sido enviado',
  processing: 'Procesando',
  pay_with_strip: 'Pagar con Stripe',
  reupload: 'Volver a subir',
  upload: 'Subir',
  files: 'Archivos'
}

const it = {
  complete: 'Completa',
  sign_and_complete: 'Firma e Completa',
  invite: 'Invita',
  email: 'Email',
  approved: 'Approvato',
  reviewed: 'Revisionato',
  other: 'Altro',
  authored_by_me: 'Creato da me',
  approved_by: 'Approvato da',
  reviewed_by: 'Revisionato da',
  authored_by: 'Creato da',
  select_a_reason: 'Seleziona una ragione',
  value_is_invalid: 'Il valore non è valido',
  verification_code_is_invalid: 'Il codice di verifica non è valido',
  drawn_signature_on_a_touchscreen_device: 'Firma disegnata su un dispositivo con schermo tattile',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Scansiona il codice QR con l\'app della fotocamera per aprire il modulo sul cellulare e disegnare la tua firma',
  by_clicking_you_agree_to_the: 'Cliccando su "{button}", accetti il',
  electronic_signature_disclosure: 'Divulgazione della Firma Elettronica',
  esignature_disclosure: 'Divulgazione della eFirma',
  minimize: 'Minimizza',
  already_paid: 'Pagato',
  text: 'Testo',
  signature: 'Firma',
  digitally_signed_by: 'Firmato digitalmente da',
  reason: 'Motivo',
  initials: 'Iniziali',
  date: 'Data',
  number: 'Numero',
  image: 'Immagine',
  pay: 'Pagamento',
  file: 'File',
  select: 'Seleziona',
  checkbox: 'Checkbox',
  multiple: 'Multiplo',
  radio: 'Radio',
  cells: 'Celle',
  stamp: 'Timbro',
  payment: 'Pagamento',
  number_phone_is_invalid: '{number} telefono non è valido',
  phone: 'Telefono',
  start_now: 'Inizia ora',
  continue: 'Continua',
  sign_now: 'Firma ora',
  type_here_: 'Digita qui...',
  optional: 'opzionale',
  appears_on: 'Compare su',
  page: 'Pagina',
  take_photo: 'Scattare una foto',
  select_your_option: 'Seleziona la tua opzione',
  complete_hightlighted_checkboxes_and_click: 'Completa le caselle evidenziate e fai clic',
  submit: 'invia',
  next: 'avanti',
  click_to_upload: 'Clicca per caricare',
  or_drag_and_drop_files: 'oppure trascina e rilascia i file',
  send_copy_via_email: 'Invia copia via email',
  download: 'Scarica',
  clear: 'Cancella',
  redraw: 'Ridisegna',
  draw_initials: 'Disegna iniziali',
  type_signature_here: 'Scrivi la firma qui',
  type_initial_here: 'Scrivi le iniziali qui',
  form_has_been_completed: 'Il modulo è stato completato!',
  document_has_been_signed: 'Il documento è stato firmato!',
  documents_have_been_signed: 'I documenti sono stati firmati!',
  create_a_free_account: 'Crea un Account Gratuito',
  powered_by: 'Desarrollado por',
  please_check_the_box_to_continue: 'Si prega di spuntare la casella per continuare',
  open_source_documents_software: 'software di documenti open source',
  verified_phone_number: 'Verifica numero di telefono',
  use_international_format: 'Usa formato internazionale: +1xxx',
  six_digits_code: 'Codice a 6 cifre',
  change_phone_number: 'Cambia numero di telefono',
  sending: 'Invio in corso...',
  resend_code: 'Rinvia codice',
  verification_code_has_been_resent: 'Il codice di verifica è stato rinviato tramite SMS',
  please_fill_all_required_fields: 'Si prega di compilare tutti i campi obbligatori',
  set_today: 'Imposta Oggi',
  draw_signature: 'Disegna firma',
  type_initial: 'Inserisci iniziali',
  draw: 'Disegna',
  type: 'Inserisci',
  type_text: 'Inserisci testo',
  toggle_multiline_text: 'Attiva Testo Multilinea',
  email_has_been_sent: "L'email è stata inviata",
  processing: 'Elaborazione',
  pay_with_strip: 'Paga con Stripe',
  reupload: 'Ricarica',
  upload: 'Carica',
  files: 'File'
}

const de = {
  complete: 'Abschließen',
  sign_and_complete: 'Signieren und Abschließen',
  invite: 'Einladen',
  email: 'E-Mail',
  approved: 'Genehmigt',
  reviewed: 'Überprüft',
  other: 'Andere',
  authored_by_me: 'Von mir verfasst',
  approved_by: 'Genehmigt von',
  reviewed_by: 'Überprüft von',
  authored_by: 'Verfasst von',
  select_a_reason: 'Grund auswählen',
  value_is_invalid: 'Wert ist ungültig',
  verification_code_is_invalid: 'Bestätigungscode ist ungültig',
  drawn_signature_on_a_touchscreen_device: 'Gezeichnete Unterschrift auf einem Touchscreen-Gerät',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Scannen Sie den QR-Code mit der Kamera-App, um das Formular auf dem Handy zu öffnen und Ihre Unterschrift zu zeichnen',
  by_clicking_you_agree_to_the: 'Durch Klicken auf "{button}" stimmen Sie zu, dass Sie die',
  electronic_signature_disclosure: 'Elektronische Unterschriftenoffenlegung',
  esignature_disclosure: 'eSignatur Offenlegung',
  already_paid: 'Bereits bezahlt',
  minimize: 'Minimieren',
  text: 'Text',
  signature: 'Unterschrift',
  digitally_signed_by: 'Digital unterschrieben von',
  reason: 'Grund',
  initials: 'Initialen',
  date: 'Datum',
  number: 'Nummer',
  image: 'Bild',
  pay: 'Bezahlen',
  file: 'Datei',
  select: 'Auswählen',
  checkbox: 'Checkbox',
  multiple: 'Mehrere',
  radio: 'Radio',
  cells: 'Zellen',
  stamp: 'Stempel',
  payment: 'Zahlung',
  number_phone_is_invalid: '{number} Telefonnummer ist ungültig',
  phone: 'Telefon',
  start_now: 'Jetzt starten',
  continue: 'Fortsetzen',
  sign_now: 'Jetzt unterschreiben',
  type_here_: 'Hier eingeben...',
  optional: 'optional',
  appears_on: 'Erscheint auf',
  page: 'Seite',
  take_photo: 'Foto aufnehmen',
  select_your_option: 'Wähle deine Option',
  complete_hightlighted_checkboxes_and_click: 'Markierte Kontrollkästchen ausfüllen und klicken',
  submit: 'absenden',
  next: 'weiter',
  click_to_upload: 'Klicken zum Hochladen',
  or_drag_and_drop_files: 'oder Dateien hierher ziehen und ablegen',
  send_copy_via_email: 'Kopie per E-Mail senden',
  download: 'Herunterladen',
  clear: 'Löschen',
  redraw: 'Neu zeichnen',
  draw_initials: 'Initialen zeichnen',
  type_signature_here: 'Unterschrift hier eingeben',
  type_initial_here: 'Initialen hier eingeben',
  form_has_been_completed: 'Formular wurde ausgefüllt!',
  document_has_been_signed: 'Dokument wurde unterschrieben!',
  documents_have_been_signed: 'Dokumente wurden unterschrieben!',
  create_a_free_account: 'Kostenloses Konto erstellen',
  powered_by: 'Bereitgestellt von',
  please_check_the_box_to_continue: 'Bitte setzen Sie das Häkchen, um fortzufahren',
  open_source_documents_software: 'Open-Source-Dokumentensoftware',
  verified_phone_number: 'Telefonnummer überprüfen',
  use_international_format: 'Internationales Format verwenden: +1xxx',
  six_digits_code: '6-stelliger Code',
  change_phone_number: 'Telefonnummer ändern',
  sending: 'Senden...',
  resend_code: 'Code erneut senden',
  verification_code_has_been_resent: 'Die Verifizierungscode wurde erneut per SMS gesendet',
  please_fill_all_required_fields: 'Bitte füllen Sie alle erforderlichen Felder aus',
  set_today: 'Heute einstellen',
  draw_signature: 'Unterschrift zeichnen',
  type_initial: 'Initialen eingeben',
  draw: 'Zeichnen',
  type: 'Eingeben',
  type_text: 'Text eingeben',
  toggle_multiline_text: 'Mehrzeiligen Text umschalten',
  email_has_been_sent: 'Die E-Mail wurde gesendet',
  processing: 'Verarbeitung',
  pay_with_strip: 'Mit Stripe bezahlen',
  reupload: 'Erneut hochladen',
  upload: 'Hochladen',
  files: 'Dateien'
}

const fr = {
  complete: 'Terminer',
  sign_and_complete: 'Signer et Terminer',
  invite: 'Inviter',
  email: 'Courriel',
  approved: 'Approuvé',
  reviewed: 'Révisé',
  other: 'Autre',
  authored_by_me: 'Rédigé par moi',
  approved_by: 'Approuvé par',
  reviewed_by: 'Révisé par',
  authored_by: 'Rédigé par',
  select_a_reason: 'Sélectionnez une raison',
  value_is_invalid: 'La valeur est invalide',
  verification_code_is_invalid: 'Le code de vérification est invalide',
  drawn_signature_on_a_touchscreen_device: 'Signature dessinée sur un appareil à écran tactile',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Scannez le code QR avec l\'application de l\'appareil photo pour ouvrir le formulaire sur mobile et dessiner votre signature',
  by_clicking_you_agree_to_the: 'En cliquant sur "{button}", vous acceptez la',
  electronic_signature_disclosure: 'Divulgation de Signature Électronique',
  esignature_disclosure: 'Divulgation de la eSignature',
  minimize: 'Réduire',
  text: 'Texte',
  already_paid: 'Déjà payé',
  signature: 'Signature',
  initials: 'Initiales',
  digitally_signed_by: 'Signé numériquement par',
  reason: 'Raison',
  pay: 'Payer',
  date: 'Date',
  number: 'Numéro',
  image: 'Image',
  file: 'Fichier',
  select: 'Choisir',
  checkbox: 'Coche',
  multiple: 'Multiple',
  radio: 'Radio',
  cells: 'Cellules',
  stamp: 'Tampon',
  payment: 'Paiement',
  number_phone_is_invalid: '{number} téléphone est invalide',
  phone: 'Téléphone',
  start_now: 'Commencer maintenant',
  continue: 'Continuer',
  sign_now: 'Signer maintenant',
  type_here_: 'Tapez ici...',
  optional: 'facultatif',
  appears_on: 'Apparaît sur',
  page: 'Page',
  take_photo: 'Prendre une photo',
  select_your_option: 'Sélectionnez votre option',
  complete_hightlighted_checkboxes_and_click: 'Complétez les cases à cocher en surbrillance et cliquez',
  submit: 'envoyer',
  next: 'suivant',
  click_to_upload: 'Cliquez pour télécharger',
  or_drag_and_drop_files: 'ou faites glisser-déposer les fichiers',
  send_copy_via_email: 'Envoyer une copie par e-mail',
  download: 'Télécharger',
  clear: 'Effacer',
  redraw: 'Redessiner',
  draw_initials: 'Dessiner les initiales',
  type_signature_here: 'Tapez la signature ici',
  type_initial_here: 'Tapez les initiales ici',
  form_has_been_completed: 'Le formulaire a été complété !',
  document_has_been_signed: 'Le document a été signé!',
  documents_have_been_signed: 'Les documents ont été signés!',
  create_a_free_account: 'Créer un Compte Gratuit',
  powered_by: 'Propulsé par',
  please_check_the_box_to_continue: 'Veuillez cocher la case pour continuer',
  open_source_documents_software: 'logiciel de documents open source',
  verified_phone_number: 'Vérifier le numéro de téléphone',
  use_international_format: 'Utiliser le format international : +1xxx',
  six_digits_code: 'Code à 6 chiffres',
  change_phone_number: 'Changer le numéro de téléphone',
  sending: 'Envoi en cours...',
  resend_code: 'Renvoyer le code',
  verification_code_has_been_resent: 'Le code de vérification a été renvoyé par SMS',
  please_fill_all_required_fields: 'Veuillez remplir tous les champs obligatoires',
  set_today: "Définir Aujourd'hui",
  draw_signature: 'Dessiner une signature',
  type_initial: 'Saisir les initiales',
  draw: 'Dessiner',
  type: 'Saisir',
  type_text: 'Saisir du texte',
  toggle_multiline_text: 'Basculer le Texte Multiligne',
  email_has_been_sent: "L'email a été envoyé",
  processing: 'Traitement',
  pay_with_strip: 'Paiement avec Stripe',
  reupload: 'Recharger',
  upload: 'Télécharger',
  files: 'Fichiers'
}

const pl = {
  complete: 'Zakończ',
  sign_and_complete: 'Podpisz i zakończ',
  invite: 'Zaproś',
  email: 'E-mail',
  approved: 'Zaakceptowany',
  reviewed: 'Przejrzany',
  other: 'Inny',
  authored_by_me: 'Napisane przeze mnie',
  approved_by: 'Zaakceptowany przez',
  reviewed_by: 'Przejrzany przez',
  authored_by: 'Napisane przez',
  select_a_reason: 'Wybierz powód',
  value_is_invalid: 'Wartość jest nieprawidłowa',
  verification_code_is_invalid: 'Kod weryfikacyjny jest nieprawidłowy',
  drawn_signature_on_a_touchscreen_device: 'Podpis odręczny na urządzeniu z ekranem dotykowym',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Zeskanuj kod QR za pomocą aplikacji aparatu, aby otworzyć formularz na telefonie i narysować swój podpis',
  by_clicking_you_agree_to_the: 'Klikając na "{button}", zgadzasz się na',
  electronic_signature_disclosure: 'Ujawnienie Elektronicznej Sygnatury',
  esignature_disclosure: 'Ujawnienie ePodpisu',
  minimize: 'Zminimalizuj',
  text: 'Tekst',
  already_paid: 'Już zapłacono',
  digitally_signed_by: 'Podpisano cyfrowo przez',
  reason: 'Powód',
  signature: 'Podpis',
  initials: 'Inicjały',
  date: 'Data',
  number: 'Numer',
  image: 'Obraz',
  file: 'Plik',
  pay: 'Zapłać',
  select: 'Wybierz',
  checkbox: 'Pole wyboru',
  multiple: 'Wielokrotne',
  radio: 'Radio',
  cells: 'Komórki',
  stamp: 'Pieczątka',
  payment: 'Płatność',
  number_phone_is_invalid: '{number} telefon jest nieprawidłowy',
  phone: 'Telefon',
  start_now: 'Zacznij teraz',
  continue: 'Kontynuuj',
  sign_now: 'Podpisz teraz',
  type_here_: 'Wpisz tutaj...',
  optional: 'opcjonalny',
  appears_on: 'Pojawia się na',
  page: 'Strona',
  select_your_option: 'Wybierz swoją opcję',
  complete_hightlighted_checkboxes_and_click: 'Wypełnij zaznaczone pola wyboru i kliknij',
  submit: 'wyślij',
  next: 'dalej',
  take_photo: 'Zrób zdjęcie',
  click_to_upload: 'Kliknij, aby przesłać',
  or_drag_and_drop_files: 'lub przeciągnij i upuść pliki',
  send_copy_via_email: 'Wyślij kopię drogą mailową',
  download: 'Pobierz',
  clear: 'Wyczyść',
  redraw: 'Przerysuj',
  draw_initials: 'Narysuj inicjały',
  type_signature_here: 'Wpisz podpis tutaj',
  type_initial_here: 'Wpisz inicjały tutaj',
  form_has_been_completed: 'Formularz został wypełniony!',
  document_has_been_signed: 'Dokument został podpisany!',
  documents_have_been_signed: 'Dokumenty zostały podpisane!',
  create_a_free_account: 'Utwórz darmowe konto',
  powered_by: 'Napędzany przez',
  please_check_the_box_to_continue: 'Proszę zaznaczyć pole, aby kontynuować',
  open_source_documents_software: 'oprogramowanie do dokumentów open source',
  verified_phone_number: 'Zweryfikuj numer telefonu',
  use_international_format: 'Użyj międzynarodowego formatu: +1xxx',
  six_digits_code: '6-cyfrowy kod',
  change_phone_number: 'Zmień numer telefonu',
  sending: 'Wysyłanie...',
  resend_code: 'Ponownie wyślij kod',
  verification_code_has_been_resent: 'Kod weryfikacyjny został ponownie wysłany',
  please_fill_all_required_fields: 'Proszę wypełnić wszystkie wymagane pola',
  set_today: 'Ustaw Dziś',
  draw_signature: 'Rysuj podpis',
  type_initial: 'Wprowadź inicjały',
  draw: 'Rysuj',
  type: 'Wprowadź',
  type_text: 'Wprowadź tekst',
  toggle_multiline_text: 'Przełącz Tekst Wielolinijkowy',
  email_has_been_sent: 'E-mail został wysłany',
  processing: 'Przetwarzanie',
  pay_with_strip: 'Płatność za pomocą Stripe',
  reupload: 'Ponowne przesłanie',
  upload: 'Przesyłanie',
  files: 'Pliki'
}

const uk = {
  complete: 'Завершити',
  sign_and_complete: 'Підписати і завершити',
  invite: 'Запросити',
  email: 'Електронна пошта',
  approved: 'Затверджено',
  reviewed: 'Переглянуто',
  other: 'Інше',
  authored_by_me: 'Авторство моє',
  approved_by: 'Затверджено',
  reviewed_by: 'Переглянуто',
  authored_by: 'Автор',
  select_a_reason: 'Виберіть причину',
  value_is_invalid: 'Значення є неправильним',
  verification_code_is_invalid: 'Код підтвердження є неправильним',
  drawn_signature_on_a_touchscreen_device: 'Підпис на сенсорному пристрої',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Скануйте QR-код за допомогою програми камери, щоб відкрити форму на мобільному пристрої та намалювати свій підпис',
  by_clicking_you_agree_to_the: 'Натиснувши на "{button}", ви погоджуєтеся з',
  electronic_signature_disclosure: 'Розголошення Електронного Підпису',
  esignature_disclosure: 'Розголошення еПідпису',
  minimize: 'Зменшити',
  text: 'Текст',
  already_paid: 'Вже оплачено',
  signature: 'Підпис',
  digitally_signed_by: 'Підписано в електронному вигляді',
  reason: 'Причина',
  initials: 'Ініціали',
  date: 'Дата',
  number: 'Число',
  image: 'Зображення',
  pay: 'Оплатити',
  file: 'Файл',
  select: 'Вибрати',
  checkbox: 'Прапорець',
  multiple: 'Множинний',
  radio: 'Радіо',
  cells: 'Клітинки',
  stamp: 'Штамп',
  payment: 'Платіж',
  number_phone_is_invalid: '{number} телефон недійсний',
  phone: 'Телефон',
  start_now: 'Почати зараз',
  continue: 'Продовжити',
  sign_now: 'Підписати зараз',
  type_here_: 'Введіть тут',
  optional: 'необов’язково',
  appears_on: "З'являється на",
  page: 'Сторінка',
  take_photo: 'Зробити фото',
  select_your_option: 'Виберіть варіант',
  complete_hightlighted_checkboxes_and_click: 'Заповніть позначені прапорці та натисніть',
  submit: 'надіслати',
  next: 'далі',
  click_to_upload: 'Клацніть, щоб завантажити',
  or_drag_and_drop_files: 'або перетягніть файли сюди',
  send_copy_via_email: 'Надіслати копію електронною поштою',
  download: 'Завантажити',
  clear: 'Очистити',
  redraw: 'Перемалювати',
  draw_initials: 'Намалювати ініціали',
  type_signature_here: 'Введіть підпис тут',
  type_initial_here: 'Введіть ініціали тут',
  form_has_been_completed: 'Форму заповнено!',
  document_has_been_signed: 'Документ був підписаний!',
  documents_have_been_signed: 'Документи були підписані!',
  create_a_free_account: 'Створити безкоштовний обліковий запис',
  powered_by: 'Працює на базі',
  please_check_the_box_to_continue: 'Будь ласка, позначте прапорець, щоб продовжити',
  open_source_documents_software: 'відкритий програмний засіб для документів',
  verified_phone_number: 'Підтвердіть номер телефону',
  use_international_format: 'Використовуйте міжнародний формат: +1xxx',
  six_digits_code: '6-значний код',
  change_phone_number: 'Змінити номер телефону',
  sending: 'Надсилаю...',
  resend_code: 'Повторно відправити код',
  verification_code_has_been_resent: 'Код підтвердження був повторно надісланий',
  please_fill_all_required_fields: "Будь ласка, заповніть всі обов'язкові поля",
  set_today: 'Задати Сьогодні',
  draw_signature: 'Намалюйте підпис',
  type_initial: 'Введіть ініціали',
  draw: 'Підпис',
  type: 'Текст',
  type_text: 'Введіть текст',
  toggle_multiline_text: 'Перемкнути Багаторядковий Текст',
  email_has_been_sent: 'Електронний лист був відправлений',
  processing: 'Обробка',
  pay_with_strip: 'Сплатити за допомогою Stripe',
  reupload: 'Перезавантажити',
  upload: 'Завантажити',
  files: 'Файли'
}

const cs = {
  complete: 'Dokončit',
  sign_and_complete: 'Podepsat a dokončit',
  invite: 'Pozvat',
  email: 'E-mail',
  approved: 'Schváleno',
  reviewed: 'Zkontrolováno',
  other: 'Jiné',
  authored_by_me: 'Autorem jsem já',
  approved_by: 'Schváleno kým',
  reviewed_by: 'Zkontrolováno kým',
  authored_by: 'Autorem',
  select_a_reason: 'Vyberte důvod',
  value_is_invalid: 'Hodnota je neplatná',
  verification_code_is_invalid: 'Ověřovací kód je neplatný',
  drawn_signature_on_a_touchscreen_device: 'Namalovaný podpis na dotykovém zařízení',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Naskenujte QR kód pomocí aplikace fotoaparátu, abyste otevřeli formulář na mobilním zařízení a nakreslili svůj podpis',
  by_clicking_you_agree_to_the: 'Kliknutím na "{button}" souhlasíte s',
  electronic_signature_disclosure: 'Zveřejněním Elektronického Podpisu',
  esignature_disclosure: 'Zveřejnění ePodpisu',
  already_paid: 'Už zaplaceno',
  minimize: 'Minimalizovat',
  text: 'Text',
  signature: 'Podpis',
  initials: 'Iniciály',
  date: 'Datum',
  number: 'Číslo',
  digitally_signed_by: 'Digitálně podepsáno',
  reason: 'Důvod',
  image: 'Obrázek',
  pay: 'Zaplatit',
  file: 'Soubor',
  select: 'Vybrat',
  checkbox: 'Zaškrtávací políčko',
  multiple: 'Více možností',
  radio: 'Rádio',
  cells: 'Buňky',
  stamp: 'Razítko',
  payment: 'Platba',
  phone: 'Telefon',
  number_phone_is_invalid: '{number} telefon je neplatný',
  start_now: 'Začít nyní',
  continue: 'Pokračovat',
  sign_now: 'Podepsat nyní',
  type_here_: 'Zadejte zde',
  optional: 'volitelné',
  appears_on: 'Zobrazuje se na',
  page: 'Stránka',
  select_your_option: 'Vyberte svou volbu',
  take_photo: 'Fotit',
  complete_hightlighted_checkboxes_and_click: 'Označte zvýrazněné zaškrtávací políčka a klikněte na',
  submit: 'odeslat',
  next: 'další',
  click_to_upload: 'Klikněte pro nahrání',
  or_drag_and_drop_files: 'nebo přetáhněte soubory sem',
  send_copy_via_email: 'Odeslat kopii e-mailem',
  download: 'Stáhnout',
  clear: 'Smazat',
  redraw: 'Překreslit',
  draw_initials: 'Nakreslit iniciály',
  type_signature_here: 'Sem zadejte podpis',
  type_initial_here: 'Sem zadejte iniciály',
  form_has_been_completed: 'Formulář byl dokončen!',
  document_has_been_signed: 'Dokument byl podepsán!',
  documents_have_been_signed: 'Dokumenty byly podepsány!',
  create_a_free_account: 'Vytvořit bezplatný účet',
  powered_by: 'Poháněno',
  please_check_the_box_to_continue: 'Prosím, zaškrtněte políčko pro pokračování',
  open_source_documents_software: 'open source software pro dokumenty',
  verified_phone_number: 'Ověřte telefonní číslo',
  use_international_format: 'Použijte mezinárodní formát: +1xxx',
  six_digits_code: '6-místný kód',
  change_phone_number: 'Změnit telefonní číslo',
  sending: 'Odesílání...',
  resend_code: 'Znovu odeslat kód',
  verification_code_has_been_resent: 'Ověřovací kód byl znovu odeslán',
  please_fill_all_required_fields: 'Prosím vyplňte všechny povinné položky',
  set_today: 'Nastavit Dnes',
  draw_signature: 'Nakreslit podpis',
  type_initial: 'Zadat iniciály',
  draw: 'Kreslit',
  type: 'Zadat',
  type_text: 'Zadat text',
  toggle_multiline_text: 'Přepnout Víceřádkový Text',
  email_has_been_sent: 'E-mail byl odeslán',
  processing: 'Zpracování',
  pay_with_strip: 'Zaplacení přes Stripe',
  reupload: 'Znovu nahrát',
  upload: 'Nahrát',
  files: 'Soubory'
}

const pt = {
  complete: 'Completar',
  sign_and_complete: 'Assinar e Completar',
  invite: 'Convidar',
  email: 'E-mail',
  approved: 'Aprovado',
  reviewed: 'Revisado',
  other: 'Outro',
  authored_by_me: 'Autorizado por mim',
  approved_by: 'Aprovado por',
  reviewed_by: 'Revisado por',
  authored_by: 'Autorizado por',
  select_a_reason: 'Selecione um motivo',
  value_is_invalid: 'Valor é inválido',
  verification_code_is_invalid: 'Código de verificação é inválido',
  drawn_signature_on_a_touchscreen_device: 'Assinatura desenhada em um dispositivo com tela sensível ao toque',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Escaneie o código QR com o aplicativo da câmera para abrir o formulário no celular e desenhar sua assinatura',
  by_clicking_you_agree_to_the: 'Ao clicar em "{button}", você concorda com o',
  electronic_signature_disclosure: 'Divulgação de Assinatura Eletrônica',
  esignature_disclosure: 'Divulgação da eAssinatura',
  already_paid: 'Já pago',
  minimize: 'Minimizar',
  text: 'Texto',
  signature: 'Assinatura',
  initials: 'Iniciais',
  digitally_signed_by: 'Assinado digitalmente por',
  reason: 'Razão',
  date: 'Data',
  number: 'Número',
  image: 'Imagem',
  pay: 'Pagar',
  file: 'Arquivo',
  select: 'Selecionar',
  checkbox: 'Caixa',
  multiple: 'Múltiplo',
  radio: 'Rádio',
  cells: 'Células',
  stamp: 'Carimbo',
  payment: 'Pagamento',
  number_phone_is_invalid: '{number} telefone é inválido',
  phone: 'Telefone',
  start_now: 'Começar agora',
  continue: 'Continuar',
  sign_now: 'Assinar agora',
  type_here_: 'Digite aqui',
  optional: 'opcional',
  appears_on: 'Aparece em',
  page: 'Página',
  take_photo: 'Tirar foto',
  select_your_option: 'Selecione sua opção',
  complete_hightlighted_checkboxes_and_click: 'Complete as caixas de seleção destacadas e clique',
  submit: 'enviar',
  next: 'próximo',
  click_to_upload: 'Clique para fazer o upload',
  or_drag_and_drop_files: 'ou arraste e solte arquivos',
  send_copy_via_email: 'Enviar cópia por e-mail',
  download: 'Baixar',
  clear: 'Limpar',
  redraw: 'Redesenhar',
  draw_initials: 'Desenhar iniciais',
  type_signature_here: 'Digite a assinatura aqui',
  type_initial_here: 'Digite as iniciais aqui',
  form_has_been_completed: 'O formulário foi concluído!',
  document_has_been_signed: 'O documento foi assinado!',
  documents_have_been_signed: 'Os documentos foram assinados!',
  create_a_free_account: 'Criar uma Conta Gratuita',
  powered_by: 'Desenvolvido por',
  please_check_the_box_to_continue: 'Por favor, marque a caixa para continuar',
  open_source_documents_software: 'software de documentos de código aberto',
  verified_phone_number: 'Verificar Número de Telefone',
  use_international_format: 'Use formato internacional: +1xxx',
  six_digits_code: 'Código de 6 dígitos',
  change_phone_number: 'Alterar número de telefone',
  sending: 'Enviando...',
  resend_code: 'Reenviar código',
  verification_code_has_been_resent: 'O código de verificação foi reenviado via SMS',
  please_fill_all_required_fields: 'Por favor, preencha todos os campos obrigatórios',
  set_today: 'Definir Hoje',
  draw_signature: 'Desenhar assinatura',
  type_initial: 'Inserir iniciais',
  draw: 'Desenhar',
  type: 'Inserir',
  type_text: 'Inserir texto',
  toggle_multiline_text: 'Alternar Texto Multilinha',
  email_has_been_sent: 'Email enviado',
  processing: 'Processamento',
  pay_with_strip: 'Pagar com Stripe',
  reupload: 'Reenviar',
  upload: 'Carregar',
  files: 'Arquivos'
}

const he = {
  complete: 'השלם',
  sign_and_complete: 'חתום והשלם',
  invite: 'הזמן',
  email: 'דוא"ל',
  approved: 'מאושר',
  reviewed: 'נסקר',
  other: 'אחר',
  authored_by_me: 'נכתב על ידי',
  approved_by: 'אושר על ידי',
  reviewed_by: 'נסקר על ידי',
  authored_by: 'נכתב על ידי',
  select_a_reason: 'בחר סיבה',
  value_is_invalid: 'ערך לא תקין',
  verification_code_is_invalid: 'קוד האימות אינו תקין',
  drawn_signature_on_a_touchscreen_device: 'חתימה שנוצרה במכשיר עם מסך מגע',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'סרוק את קוד ה-QR באמצעות אפליקציית המצלמה כדי לפתוח את הטופס במובייל ולצייר את החתימה שלך',
  by_clicking_you_agree_to_the: 'על ידי לחיצה על "{button}", אתה מסכים ל',
  electronic_signature_disclosure: 'חשיפת חתימה אלקטרונית',
  esignature_disclosure: 'חשיפת ה-eחתימה',
  minimize: 'לקטן',
  text: 'טקסט',
  already_paid: 'כבר שולם',
  signature: 'חתימה',
  initials: 'ראשי תיבות',
  date: 'תאריך',
  digitally_signed_by: 'חתום דיגיטלית על ידי',
  reason: 'סיבה',
  number: 'מספר',
  image: 'תמונה',
  file: 'קובץ',
  pay: 'תשלום',
  select: 'בחר',
  checkbox: 'תיק בחירה',
  multiple: 'רב ערכים',
  radio: 'רדיו',
  cells: 'תאים',
  stamp: 'חותמת',
  payment: 'תשלום',
  phone: 'טלפון',
  number_phone_is_invalid: '{number} טלפון אינו חוקי',
  start_now: 'התחל עכשיו',
  continue: 'המשך',
  sign_now: 'חתום כעת',
  type_here_: 'הקלד כאן',
  optional: 'אופציונלי',
  option: 'אפשרות',
  appears_on: 'מופיע ב',
  page: 'עמוד',
  take_photo: 'צלם תמונה',
  select_your_option: 'בחר את האפשרות שלך',
  complete_hightlighted_checkboxes_and_click: 'השלם את תיבות הסימון המודגשות ולחץ',
  submit: 'שליחה',
  next: 'הבא',
  click_to_upload: 'לחץ להעלאה',
  or_drag_and_drop_files: 'או גרור ושחרר קבצים',
  send_copy_via_email: 'שלח עותק באמצעות אימייל',
  download: 'הורדה',
  clear: 'נקה',
  redraw: 'צייר מחדש',
  draw_initials: 'צייר ציוני ראשי תיבות',
  type_signature_here: 'הקלד חתימה כאן',
  type_initial_here: 'הקלד ציוני ראשי תיבות כאן',
  form_has_been_completed: 'הטופס הושלם',
  document_has_been_signed: 'המסמך נחתם!',
  documents_have_been_signed: 'המסמכים נחתמו!',
  create_a_free_account: 'צור חשבון חינם',
  powered_by: 'מופעל על ידי',
  please_check_the_box_to_continue: 'אנא סמן את התיבה כדי להמשיך',
  open_source_documents_software: 'תוכנה פתוחה למסמכים',
  verified_phone_number: 'אימות מספר טלפון',
  use_international_format: 'השתמש בפורמט בינלאומי: +1xxx',
  six_digits_code: 'קוד משתמש שש ספרות',
  change_phone_number: 'שינוי מספר טלפון',
  sending: 'שולח',
  resend_code: 'שלח מחדש קוד',
  verification_code_has_been_resent: 'קוד האימות נשלח מחדש בSMS',
  please_fill_all_required_fields: 'אנא מלא את כל השדות הדרושים',
  set_today: 'קבע היום',
  toggle_multiline_text: 'שנה בין טקסט במספר שורות לטקסט בשורה אחת',
  draw_signature: 'צייר חתימה',
  type_initial: 'הקלד ציוני ראשי תיבות',
  draw: 'צייר',
  type: 'הקלד',
  type_text: 'הקלד טקסט',
  email_has_been_sent: 'האימייל נשלח',
  processing: 'מעבד',
  pay_with_strip: 'שלם עם סטרייפ',
  reupload: 'העלה שוב',
  upload: 'העלאה',
  files: 'קבצים'
}

const nl = {
  complete: 'Voltooien',
  sign_and_complete: 'Ondertekenen en voltooien',
  invite: 'Uitnodigen',
  email: 'E-mail',
  approved: 'Goedgekeurd',
  reviewed: 'Beoordeeld',
  other: 'Anders',
  authored_by_me: 'Door mij geschreven',
  approved_by: 'Goedgekeurd door',
  reviewed_by: 'Beoordeeld door',
  authored_by: 'Geschreven door',
  select_a_reason: 'Selecteer een reden',
  value_is_invalid: 'Waarde is ongeldig',
  verification_code_is_invalid: 'Verificatiecode is ongeldig',
  drawn_signature_on_a_touchscreen_device: 'Getekende handtekening op een apparaat met een touchscreen',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Scan de QR-code met de camera-app om het formulier op mobiel te openen en uw handtekening te tekenen',
  by_clicking_you_agree_to_the: 'Door op "{button}" te klikken, gaat u akkoord met de',
  electronic_signature_disclosure: 'Openbaarmaking van Elektronische Handtekening',
  esignature_disclosure: 'Openbaarmaking van eHandtekening',
  minimize: 'Minimaliseren',
  text: 'Tekst',
  already_paid: 'Al betaald',
  signature: 'Handtekening',
  digitally_signed_by: 'Digitaal ondertekend door',
  reason: 'Reden',
  initials: 'Initialen',
  date: 'Datum',
  number: 'Nummer',
  image: 'Afbeelding',
  take_photo: 'Maak een foto',
  file: 'Bestand',
  select: 'Selecteer',
  checkbox: 'Aankruisvakje',
  multiple: 'Meerdere',
  pay: 'Betaal',
  radio: 'Radio',
  cells: 'Cellen',
  stamp: 'Stempel',
  payment: 'Betaling',
  phone: 'Telefoon',
  number_phone_is_invalid: '{number} telefoon is ongeldig',
  start_now: 'Nu beginnen',
  continue: 'Doorgaan',
  sign_now: 'Nu ondertekenen',
  type_here_: 'Typ hier...',
  optional: 'Optioneel',
  option: 'Optie',
  appears_on: 'Verschijnt op',
  page: 'Pagina',
  select_your_option: 'Selecteer uw optie',
  complete_hightlighted_checkboxes_and_click: 'Voltooi de gemarkeerde selectievakjes en klik',
  submit: 'Voltooien',
  next: 'Volgende',
  click_to_upload: 'Klik om te uploaden',
  or_drag_and_drop_files: 'of sleep en plaats bestanden',
  send_copy_via_email: 'Stuur kopie per e-mail',
  download: 'Downloaden',
  clear: 'Wissen',
  redraw: 'Opnieuw tekenen',
  draw_initials: 'Initialen tekenen',
  type_signature_here: 'Typ hier uw handtekening',
  type_initial_here: 'Typ hier uw initialen',
  form_has_been_completed: 'Formulier is voltooid!',
  document_has_been_signed: 'Document is ondertekend!',
  documents_have_been_signed: 'De documenten zijn ondertekend!',
  create_a_free_account: 'Maak een gratis account aan',
  powered_by: 'Aangedreven door',
  please_check_the_box_to_continue: 'Vink het vakje aan om door te gaan',
  open_source_documents_software: 'Open source documenten software',
  verified_phone_number: 'Geverifieerd telefoonnummer',
  use_international_format: 'Gebruik internationaal formaat: +1xxx',
  six_digits_code: '6-cijferige code',
  change_phone_number: 'Wijzig telefoonnummer',
  sending: 'Voltooien...',
  resend_code: 'Code opnieuw verzenden',
  verification_code_has_been_resent: 'Verificatiecode is opnieuw verzonden via SMS',
  please_fill_all_required_fields: 'Vul alle verplichte velden in',
  set_today: 'Vandaag',
  toggle_multiline_text: 'Schakel meerregelige tekst in/uit',
  draw_signature: 'Handtekening tekenen',
  type_initial: 'Typ initialen',
  draw: 'Tekenen',
  type: 'Typen',
  type_text: 'Typ tekst',
  email_has_been_sent: 'E-mail is verzonden',
  processing: 'Verwerken',
  pay_with_strip: 'Betalen met Stripe',
  reupload: 'Opnieuw uploaden',
  upload: 'Uploaden',
  files: 'Bestanden'
}

const ar = {
  complete: 'اكتمال',
  sign_and_complete: 'التوقيع والاكتمال',
  invite: 'دعوة',
  email: 'البريد الإلكتروني',
  approved: 'موافق عليه',
  reviewed: 'تمت مراجعته',
  other: 'آخر',
  authored_by_me: 'مؤلف بواسطتي',
  approved_by: 'موافق عليه من قبل',
  reviewed_by: 'مراجع من قبل',
  authored_by: 'مؤلف من قبل',
  select_a_reason: 'اختر سببًا',
  value_is_invalid: 'القيمة غير صالحة',
  verification_code_is_invalid: 'رمز التحقق غير صالح',
  drawn_signature_on_a_touchscreen_device: 'توقيع مرسوم على جهاز بشاشة تعمل باللمس',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'امسح رمز الاستجابة السريعة باستخدام تطبيق الكاميرا لفتح النموذج على الهاتف المحمول ورسم توقيعك',
  by_clicking_you_agree_to_the: 'بالنقر فوق "{button}"، أنت توافق على',
  electronic_signature_disclosure: 'كشف التوقيع الإلكتروني',
  esignature_disclosure: 'كشف التوقيع الإلكتروني',
  text: 'نص',
  signature: 'توقيع',
  initials: 'الاختصارات',
  date: 'تاريخ',
  number: 'رقم',
  digitally_signed_by: 'تم التوقيع رقميًا بواسطة',
  reason: 'السبب',
  image: 'صورة',
  take_photo: 'التقاط صورة',
  pay: 'دفع',
  file: 'ملف',
  select: 'اختيار',
  checkbox: 'خانة اختيار',
  multiple: 'متعدد',
  radio: 'راديو',
  cells: 'خلايا',
  stamp: 'ختم',
  minimize: 'تصغير',
  payment: 'الدفع',
  phone: 'هاتف',
  number_phone_is_invalid: '{number} هاتف غير صالح',
  start_now: 'ابدأ الآن',
  continue: 'متابعة',
  sign_now: 'وقع الآن',
  type_here_: 'اكتب هنا',
  optional: 'اختياري',
  option: 'خيار',
  appears_on: 'يظهر على',
  page: 'صفحة',
  select_your_option: 'اختر خيارك',
  complete_hightlighted_checkboxes_and_click: 'أكمل الخانات المميزة وانقر',
  submit: 'إرسال',
  next: 'التالي',
  click_to_upload: 'انقر للتحميل',
  or_drag_and_drop_files: 'أو اسحب وأسقط الملفات',
  send_copy_via_email: 'إرسال نسخة عبر البريد الإلكتروني',
  download: 'تحميل',
  clear: 'مسح',
  redraw: 'إعادة الرسم',
  draw_initials: 'ارسم الاختصارات',
  type_signature_here: 'اكتب التوقيع هنا',
  type_initial_here: 'اكتب الاختصارات هنا',
  form_has_been_completed: 'تم إكمال النموذج!',
  document_has_been_signed: 'تم توقيع الوثيقة!',
  documents_have_been_signed: 'تم توقيع الوثائق!',
  create_a_free_account: 'إنشاء حساب مجاني',
  powered_by: 'مدعوم من',
  please_check_the_box_to_continue: 'الرجاء التحقق من الخانة للمتابعة',
  open_source_documents_software: 'برنامج وثائق مفتوح المصدر',
  verified_phone_number: 'تحقق من رقم الهاتف',
  use_international_format: 'استخدم الشكل الدولي: +1xxx',
  six_digits_code: 'رمز مكون من 6 أرقام',
  change_phone_number: 'تغيير رقم الهاتف',
  sending: 'جارٍ الإرسال',
  resend_code: 'إعادة إرسال الرمز',
  verification_code_has_been_resent: 'تم إعادة إرسال رمز التحقق عبر الرسائل القصيرة',
  please_fill_all_required_fields: 'الرجاء ملء جميع الحقول المطلوبة',
  set_today: 'تعيين اليوم',
  toggle_multiline_text: 'تبديل النصوص متعددة الأسطر',
  draw_signature: 'ارسم التوقيع',
  type_initial: 'اكتب الاختصارات',
  draw: 'ارسم',
  type: 'اكتب',
  type_text: 'اكتب نصًا',
  email_has_been_sent: 'تم إرسال البريد الإلكتروني',
  processing: 'جارٍ المعالجة',
  pay_with_strip: 'الدفع بواسطة Stripe',
  reupload: 'إعادة التحميل',
  upload: 'تحميل',
  files: 'الملفات'
}

const ko = {
  complete: '완료',
  sign_and_complete: '서명하고 완료하기',
  invite: '초대하기',
  email: '이메일',
  approved: '승인됨',
  reviewed: '검토됨',
  other: '기타',
  authored_by_me: '내가 작성한',
  approved_by: '승인자',
  reviewed_by: '검토자',
  authored_by: '작성자',
  select_a_reason: '이유 선택',
  drawn_signature_on_a_touchscreen_device: '터치스크린 장치에서 그린 서명',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: '카메라 앱으로 QR 코드를 스캔하여 모바일에서 양식을 열고 서명을 그리세요',
  by_clicking_you_agree_to_the: '"{button}"를 클릭함으로써, 다음에 동의하게 됩니다',
  electronic_signature_disclosure: '전자 서명 공개',
  esignature_disclosure: '전자 서명 공개',
  already_paid: '이미 지불됨',
  text: '텍스트',
  signature: '서명',
  initials: '이니셜',
  date: '날짜',
  digitally_signed_by: '디지털 서명이 완료되었습니다',
  reason: '이유',
  number: '숫자',
  pay: '급여',
  image: '이미지',
  take_photo: '사진 찍기',
  file: '파일',
  select: '선택',
  checkbox: '체크박스',
  multiple: '다중',
  radio: '라디오',
  cells: '셀',
  stamp: '스탬프',
  minimize: '최소화',
  payment: '결제',
  phone: '전화',
  number_phone_is_invalid: '{number} 전화번호가 유효하지 않습니다',
  start_now: '지금 시작하기',
  continue: '계속하다',
  sign_now: '지금 서명',
  type_here_: '여기에 입력...',
  optional: '선택 사항',
  option: '옵션',
  appears_on: '다음에 나타납니다',
  page: '페이지',
  select_your_option: '옵션 선택',
  complete_hightlighted_checkboxes_and_click: '강조된 체크박스를 완료하고 클릭',
  submit: '제출',
  next: '다음',
  click_to_upload: '업로드하려면 클릭',
  or_drag_and_drop_files: '또는 파일을 드래그하여 놓으십시오',
  send_copy_via_email: '이메일로 사본 보내기',
  download: '다운로드',
  clear: '지우기',
  redraw: '다시 그리기',
  draw_initials: '이니셜 그리기',
  type_signature_here: '여기에 서명 입력',
  type_initial_here: '여기에 이니셜 입력',
  form_has_been_completed: '양식이 완료되었습니다!',
  document_has_been_signed: '문서가 서명되었습니다!',
  documents_have_been_signed: '문서가 서명되었습니다!',
  create_a_free_account: '무료 계정 생성',
  powered_by: '구동',
  please_check_the_box_to_continue: '계속하려면 확인란을 선택하십시오',
  open_source_documents_software: '오픈 소스 문서 소프트웨어',
  verified_phone_number: '전화번호 확인됨',
  use_international_format: '국제 포맷 사용: +1xxx',
  six_digits_code: '6자리 코드',
  change_phone_number: '전화번호 변경',
  sending: '전송 중...',
  resend_code: '코드 다시 보내기',
  verification_code_has_been_resent: '인증 코드가 SMS로 다시 전송되었습니다',
  please_fill_all_required_fields: '필수 필드를 모두 입력하십시오',
  set_today: '오늘 날짜로 설정',
  toggle_multiline_text: '다중 텍스트 전환',
  draw_signature: '서명 그리기',
  type_initial: '이니셜 입력',
  draw: '그리기',
  type: '입력',
  type_text: '텍스트 입력',
  email_has_been_sent: '이메일이 전송되었습니다',
  processing: '처리 중',
  pay_with_strip: '스트라이프로 결제',
  reupload: '다시 업로드',
  upload: '업로드',
  files: '파일'
}

const i18n = { en, es, it, de, fr, pl, uk, cs, pt, he, nl, ar, ko }

export default i18n
